import { message, Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import { EntDirectoryInfoName } from '../../../../../models/directoryInfoName'
import { getCookie } from 'typescript-cookie'
import {
	useAddVeterinaryProductCategoryMutation,
	useEditVeterinaryProductCategoryMutation,
	useDeleteVeterinaryProductCategoryMutation,
} from '../../../../../redux/api/handBooksApi/veterinary/veterinaryProductionCategoryApi'

const useVeterinaryProductCategory = (modal: any, refresh?: () => void) => {
	const { t } = useTranslation()
	const { confirm } = modal
	const [addVeterinaryProductCategory] = useAddVeterinaryProductCategoryMutation()
	const [deleteVeterinaryProductCategory] = useDeleteVeterinaryProductCategoryMutation()
	const [editVeterinaryProductCategory] = useEditVeterinaryProductCategoryMutation()

	async function onAddVeterinaryProductCategory(
		newVeterinaryProductCategory: EntDirectoryInfoName
	): Promise<boolean> {
		try {
			let status: boolean = false
			await addVeterinaryProductCategory(newVeterinaryProductCategory)
				.then((response: any) => {
					if (response.error) {
						const isKyrgyz = getCookie('i18next') === 'ky'
						const lang = isKyrgyz ? 'kg' : 'ru'
						const res = response.error.data?.res
						const errorMessages = Array.isArray(res)
							? res.map((error: any) => error[lang] || error.ru).join('\n')
							: response.error.data?.msg || t('unknownError')
						throw new Error(errorMessages)
					}
					if (response.data.success) {
						status = true
						message.success(t('msg.successAdd'))
						if (refresh) refresh()
					}
				})
				.catch((error: any) => {
					modal.error({ title: t('msg.error'), content: String(error.message) })
				})
			return status
		} catch (error: any) {
			modal.error({ title: t('msg.error'), content: String(error.message) })
			return false
		}
	}

	async function onDeleteVeterinaryProductCategory(
		veterinaryProductCategory: EntDirectoryInfoName
	) {
		try {
			let status: boolean = false
			confirm({
				centered: true,
				title: t('msg.confirmDeleteText'),
				okText: t('general.yes'),
				cancelText: t('general.no'),
				onOk() {
					deleteVeterinaryProductCategory(veterinaryProductCategory.id as number)
						.then((response: any) => {
							if (response.error) {
								const isKyrgyz = getCookie('i18next') === 'ky'
								const lang = isKyrgyz ? 'kg' : 'ru'
								const res = response.error.data?.res
								const errorMessages = Array.isArray(res)
									? res.map((error: any) => error[lang] || error.ru).join('\n')
									: response.error.data?.msg || t('unknownError')
								throw new Error(errorMessages)
							}
							if (response.data.success) {
								status = true
								Modal.success({ title: t('msg.successDelete') })
								if (refresh) refresh()
							}
						})
						.catch((error: any) => {
							Modal.error({ title: t('msg.error'), content: String(error.message) })
						})
				},
			})
			return status
		} catch (error: any) {
			Modal.error({ title: t('msg.error'), content: String(error.message) })
			return false
		}
	}

	async function onEditVeterinaryProductCategory(
		editedVeterinaryProductCategory: EntDirectoryInfoName
	): Promise<boolean> {
		try {
			let status: boolean = false
			await editVeterinaryProductCategory(editedVeterinaryProductCategory)
				.then((response: any) => {
					if (response.error) {
						const isKyrgyz = getCookie('i18next') === 'ky'
						const lang = isKyrgyz ? 'kg' : 'ru'
						const res = response.error.data?.res
						const errorMessages = Array.isArray(res)
							? res.map((error: any) => error[lang] || error.ru).join('\n')
							: response.error.data?.msg || t('unknownError')
						throw new Error(errorMessages)
					}
					if (response.data.success) {
						status = true
						Modal.success({ title: t('msg.successEdited') })
						if (refresh) refresh()
					}
				})
				.catch((error: any) => {
					Modal.error({ title: t('msg.error'), content: String(error.message) })
				})
			return status
		} catch (error: any) {
			Modal.error({ title: t('msg.error'), content: String(error.message) })
			return false
		}
	}

	return {
		onAddVeterinaryProductCategory,
		onDeleteVeterinaryProductCategory,
		onEditVeterinaryProductCategory,
	}
}

export { useVeterinaryProductCategory }
